import { render, staticRenderFns } from "./border-input.vue?vue&type=template&id=287d8871&scoped=true"
import script from "./border-input.vue?vue&type=script&lang=js"
export * from "./border-input.vue?vue&type=script&lang=js"
import style0 from "./border-input.vue?vue&type=style&index=0&id=287d8871&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287d8871",
  null
  
)

export default component.exports